import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'involvement-categories';

export function useGetAllInvolvementCategories(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetInvolvementCategory(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateInvolvementCategory() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateInvolvementCategory({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteInvolvementCategory({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
